import { parseDate } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { AccountImportsResponse } from "@syla/shared/types/responses/AccountImportsResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function getAccountImports(
  accountId: string,
): Promise<AccountImportsResponse> {
  try {
    const response = await axios.get<TransportType<AccountImportsResponse>>(
      `/accounts/${accountId}/transactions/imports`,
    );
    return deserialise(response.data);
  } catch (error) {
    throwSylaApiError(error);
  }
}

function deserialise(
  data: TransportType<AccountImportsResponse>,
): AccountImportsResponse {
  return {
    imports: data.imports.map((accountImport) => ({
      transactionCount: accountImport.transactionCount,
      import: {
        ...accountImport.import,
        date: parseDate(accountImport.import.date),
      },
    })),
  };
}
